export default __webpack_public_path__ + "static/media/notification_up.3b962d31.mp3";